import { render, staticRenderFns } from "./Chat.demo.vue?vue&type=template&id=5a34ac3d&scoped=true&"
import script from "./Chat.demo.vue?vue&type=script&lang=js&"
export * from "./Chat.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a34ac3d",
  null
  
)

export default component.exports